<script lang="ts">
	type IconName =
		| 'arrow'
		| 'at'
		| 'backup'
		| 'browser'
		| 'check'
		| 'close'
		| 'database'
		| 'external'
		| 'file'
		| 'install'
		| 'lock'
		| 'mail'
		| 'menu'
		| 'message'
		| 'monitor'
		| 'phone'
		| 'server'
		| 'shield'
		| 'story';

	let { name, size = 24 } = $props<{ name: IconName; size?: number }>();
</script>

<svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
	{#if name === 'menu'}
		<path d="M4 7h16M4 12h16M4 17h16" />
	{:else if name === 'close'}
		<path d="m6 6 12 12M18 6 6 18" />
	{:else if name === 'arrow'}
		<path d="M5 12h14M14 7l5 5-5 5" />
	{:else if name === 'external'}
		<path d="M14 5h5v5M19 5l-8 8M18 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
	{:else if name === 'message'}
		<path d="M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-5 3v-3H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
	{:else if name === 'phone'}
		<path
			d="M7.2 3.5 4.6 5.1c-.8.5-1.1 1.5-.8 2.4 2 5.6 6.3 9.9 11.9 11.9.9.3 1.9 0 2.4-.8l1.6-2.6-4.2-2-1.3 1.7a14.7 14.7 0 0 1-5.9-5.9L10 8.5l-2.8-5Z"
		/>
	{:else if name === 'mail'}
		<rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" />
	{:else if name === 'story'}
		<circle cx="12" cy="12" r="8" stroke-dasharray="4 3" /><path d="M10 9.5 15 12l-5 2.5v-5Z" />
	{:else if name === 'file'}
		<path d="M7 3h7l4 4v14H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" /><path d="M14 3v5h5M9 13h6M9 17h4" />
	{:else if name === 'lock'}
		<rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
	{:else if name === 'shield'}
		<path d="M12 3 20 6v5c0 5-3.4 8.3-8 10-4.6-1.7-8-5-8-10V6l8-3Z" /><path
			d="m8.5 12 2.2 2.2 4.8-5"
		/>
	{:else if name === 'database'}
		<ellipse cx="12" cy="5" rx="7" ry="3" /><path
			d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6"
		/>
	{:else if name === 'server'}
		<rect x="4" y="3" width="16" height="7" rx="2" /><rect
			x="4"
			y="14"
			width="16"
			height="7"
			rx="2"
		/><path d="M8 6.5h.01M8 17.5h.01M12 6.5h5M12 17.5h5" />
	{:else if name === 'backup'}
		<path d="M4 12a8 8 0 1 0 2.3-5.7L4 9" /><path d="M4 4v5h5M12 8v5l3 2" />
	{:else if name === 'browser'}
		<rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18M7 6.5h.01M10 6.5h.01" />
	{:else if name === 'monitor'}
		<rect x="3" y="3" width="18" height="13" rx="2" /><path d="M8 21h8M12 16v5" />
	{:else if name === 'install'}
		<path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
	{:else if name === 'at'}
		<circle cx="12" cy="12" r="8" /><path
			d="M16 12v2a2 2 0 0 0 4 0v-2a8 8 0 1 0-3.3 6.5M16 12a4 4 0 1 1-4-4 4 4 0 0 1 4 4Z"
		/>
	{:else if name === 'check'}
		<path d="m5 12 4 4L19 6" />
	{/if}
</svg>

<style>
	svg {
		display: block;
		stroke: currentColor;
		stroke-width: 1.8;
		stroke-linecap: round;
		stroke-linejoin: round;
	}
</style>
